import { makeStyles } from 'tss-react/mui';

export const useCatalogCardTagsStyles = makeStyles()((theme) => ({
  root: {
    position: 'absolute',
    bottom: theme.spacing(1.5),
    right: theme.spacing(1.5),
    left: theme.spacing(1.5),
    pointerEvents: 'none',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
  },
}));
